/**
* Call To Action JS
* -----------------------------------------------------------------------------
*
* All the JS for the Call To Action component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';

( function( app ) {
  const COMPONENT = {

    className: 'call-to-action',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );

      CustomEase.create( 'fastForward', 'M0,0,C0.266,0.412,0.451,0.545,0.58,0.666,0.612,0.696,0.753,0.829,0.87,0.914,0.928,0.956,0.942,1,1,1 ' );

      const sections = gsap.utils.toArray( '.call-to-action' );

      sections.forEach( ( section ) => {
        const topYellow = section.querySelector( '.arrows-small .blue-arrow' );
        const topBlue = section.querySelector( '.arrows-small .yellow-arrow-outline' );
        const bottomYellow = section.querySelector( '.arrows-large .blue-arrow' );
        const bottomBlue = section.querySelector( '.arrows-large .yellow-arrow-outline' );
        const topYellowLine = section.querySelector( '.top-lines .yellow-line' );
        const topGreenLine = section.querySelector( '.top-lines .green-line' );
        const bottomYellowLine = section.querySelector( '.bottom-lines .yellow-line' );
        const bottomGreenLine = section.querySelector( '.bottom-lines .green-line' );

        gsap
            .timeline( {
              scrollTrigger: {
                trigger: section,
                start: 'top 60%',
                scrub: false,
              },
            } )
            .from( topYellowLine, {x: '-100vw', ease: 'fastForward'}, 0 )
            .from( topGreenLine, {x: '-100vw', ease: 'fastForward'}, 0.25 )
            .from( bottomYellowLine, {xPercent: -130, ease: 'fastForward'}, 0 )
            .from( bottomGreenLine, {xPercent: -130, ease: 'fastForward'}, 0.25 )
            .from( topYellow, {xPercent: -130, ease: 'fastForward'}, 0.5 )
            .from( topBlue, {xPercent: -130, ease: 'fastForward'}, 0.75 )
            .from( bottomYellow, {x: '-100vw', ease: 'fastForward'}, 0.5 )
            .from( bottomBlue, {x: '-100vw', ease: 'fastForward'}, 0.75 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'call-to-action', COMPONENT );
} )( app );
